import { Box, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Styled button for the clickable tab header.
 */
export const HelixTab = styled('button')(() => (Object.assign(Object.assign({}, HelixStyles.style_06_medium), { alignItems: 'center', border: 'none', borderRadius: '0.5rem 0.5rem 0 0', borderBottom: `2px solid ${HelixPalette.neutral30}`, backgroundColor: HelixPalette.white, display: 'flex', maxHeight: '42px', minHeight: '42px', padding: '0.5rem 0.75rem', position: 'relative', svg: { fontSize: 20 }, '&.tab-action-required': {
        paddingRight: '0.25rem',
    }, '&:focus': { outline: 'none' }, '&:hover': {
        color: HelixPalette.teal70,
        cursor: 'pointer',
        svg: { fill: HelixPalette.teal70 },
    }, '&:active:focus': {
        color: HelixPalette.teal90,
        svg: { fill: HelixPalette.teal90 },
    }, '&[aria-selected=true]': {
        borderBottomColor: HelixPalette.teal80,
        color: HelixPalette.teal80,
        svg: { fill: HelixPalette.teal80 },
    }, '&:focus-visible': {
        padding: '0.375rem 0.625rem 0.5rem',
        border: `2px solid ${HelixPalette.blue70}`,
        '&.tab-action-required': {
            paddingRight: '0.125rem',
        },
    }, '&[aria-disabled=true]': {
        borderBottomColor: HelixPalette.neutral30,
        color: HelixPalette.neutral50,
        cursor: 'default',
        svg: { fill: HelixPalette.neutral50 },
        '&:focus-visible': {
            padding: '0.375rem 0.625rem 0.5rem',
            border: `2px solid ${HelixPalette.blue70}`,
        },
        '&:active:focus': {
            color: HelixPalette.neutral50,
            svg: { fill: HelixPalette.neutral50 },
        },
    } })));
/**
 * Styled Box for the list of tab headers.
 */
export const HelixTabList = styled(Box)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    minHeight: '40px',
}));
/**
 * Styled Box for the tab panel holding the content.
 */
export const HelixTabPanel = styled(Box)(() => ({ paddingTop: '1rem' }));
/**
 * Styled Box for the top level tab div.
 */
export const HelixTabs = styled(Box)(() => ({
    width: '100%',
}));
